import { createApi } from '@reduxjs/toolkit/query/react';

import { IApplicationContext } from '../types/ICustomContextParams';
import { fetchGetAgentInfo } from '../../node/repositories/agent-card/v3/get-agent-info';
import { IGetAgentInfoResponseV3Schema } from '../../node/repositories/agent-card/entities/agent_info/GetAgentInfoResponseV3Schema';
import { createBaseQuery } from './utils/createBaseQuery';

export type TRealtorInfoApiEndpoints = keyof typeof realtorInfoApi.endpoints;
export let realtorInfoApi: ReturnType<typeof createRealtorInfoApi>;

export const createRealtorInfoApi = (ctx: IApplicationContext) => {
  const newApi = createApi({
    reducerPath: 'realtorInfoApi',
    baseQuery: createBaseQuery(ctx),
    endpoints: builder => ({
      getRealtorInfo: builder.query<
        IGetAgentInfoResponseV3Schema,
        {
          cianUserId: number;
          accountType?: string;
        }
      >({
        query: parameters => {
          return {
            parameters: {
              ...parameters,
              accountType: 'specialist',
            },
            fetchFunction: fetchGetAgentInfo,
            loggerInfo: {
              description: 'Получение информации о риелторе',
              degradation: 'Не критическая ошибка',
            },
          };
        },
      }),
    }),
  });

  realtorInfoApi = newApi;

  return newApi;
};
